define('AwaLabs.GoogleCaptcha', [
	'GoogleCaptcha.View',
	'jQuery',
	'SC.Configuration',
	'underscore',
	'AwaLabs.BackboneFormView.GoogleCaptchaToken'
], function AwaLabsGoogleCaptcha(
	GoogleCaptchaView,
	jQuery,
	Configuration,
	_
) {
	'use strict';

	return {
		mountToApp: function mountToApp(application) {
			var self = this;
			var googleCaptchaKey = Configuration.get('googlecaptcha.siteKey');
			this.application = application;
			this.layout = application.getComponent('Layout');
			if (googleCaptchaKey) {
				application.getLayout().on('afterAppendView', function onAfterAppendView() {
					var language = _.findWhere(SC.CONFIGURATION.siteSettings.sitelanguage, { isdefault: 'T' }).locale;
					jQuery.getScript('//www.google.com/recaptcha/api.js?render=' + googleCaptchaKey + '&hl=' + language)
						.done(function captchaDone(response) {
							self.layout.cancelableTrigger('after:googleCaptchaLoad', {
								grecaptcha: grecaptcha,
								response: response
							});
						});
				});

				this.addCaptchaToForms(application);
			} else {
				console.warn('AwaGoogleCaptcha', 'Installed but site key is missing');
			}
		},
		createFieldView: function createFieldView(form) {
			var view;
			view = new GoogleCaptchaView({
				application: this.application,
				action: form.action
			});
			this.layout.addChildView(form.dataView, function addChildView() {
				return view;
			});
		},
		addDataAttribute: function addDataAttribute(form) {
			this.layout.on('afterShowContent', function addAttr() {
				jQuery(form.querySelector).attr('data-googlecaptcha-action', form.action);
			});
		},
		addCheckoutModule: function addCheckoutModule() {
			var checkout = this.application.getComponent('Checkout');
			if (checkout) {
				require('OrderWizard.Module.CaptchaVerification');
				checkout.addModuleToStep({
					step_url: 'review',
					module: {
						id: 'captchaVerification',
						index: 1,
						classname: 'OrderWizard.Module.CaptchaVerification'
					}
				});
			}
		},
		addCaptchaToForms: function addCaptchaToForms() {
			var self = this;
			var forms = Configuration.get('googlecaptcha.Forms');

			_.each(forms, function addCaptchaToForm(form) {
				if (form.action === 'order' && form.isActive) {
					self.addCheckoutModule(form);
				} else {
					if (form.dataView && form.isActive) {
						self.createFieldView(form);
					}
					if (form.querySelector && form.isActive) {
						self.addDataAttribute(form);
					}
				}
			});
		}
	};
});
